var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.9296875 22c0 .5522461.4472656 1 1 1s1-.4477539 1-1c0-3.5288086 2.0314941-6.6528931 5.1980591-8.130249 1.0958862.7121582 2.3995972 1.130249 3.8009643 1.130249 1.4066772 0 2.7153931-.4208984 3.8138428-1.1380615.9453125.446228 1.8213501 1.0466309 2.550415 1.7752686 1.7001954 1.7006835 2.6367188 3.9604492 2.6367188 6.3627929 0 .5522461.4472656 1 1 1s1-.4477539 1-1c0-2.9365234-1.1445313-5.6982422-3.2226563-7.7768555-.6953735-.6957397-1.50354-1.2922974-2.3706055-1.7841187.9942017-1.2089233 1.5922852-2.75531 1.5922852-4.4390258 0-3.8598633-3.140625-7-7-7s-7 3.1401367-7 7c0 1.6796265.5956421 3.222229 1.5854492 4.4298706-3.4328002 1.9327393-5.5844726 5.5439453-5.5844726 9.5701294zm10.9990234-19c2.7568359 0 5 2.2431641 5 5s-2.2431641 5-5 5-5-2.2431641-5-5 2.2431641-5 5-5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my-profile.8a21130dc276f656241cd04615bd382e.svg";
export { ForwardRef as ReactComponent };